<template>
  <div class="space-y-4">
    <div>
      <label
        class="block text-xs font-bold text-gray-500 uppercase tracking-wider mb-1.5"
        for="stripe-cardholder-name"
      >
        Cardholder Name
      </label>
      <div class="relative">
        <input
          id="stripe-cardholder-name"
          type="text"
          :value="cardholderName"
          @input="$emit('update:cardholderName', $event.target.value)"
          placeholder="Name on Card"
          :class="[
            'w-full p-3 pl-10 rounded-xl border bg-white shadow-sm focus:border-primary-500 outline-none transition-all',
            cardholderNameError
              ? 'border-red-400 focus:border-red-500 focus:ring-2 focus:ring-red-200'
              : 'border-gray-200'
          ]"
        />
        <User
          :size="18"
          class="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400"
          style="transform: translateY(-50%);"
        />
      </div>
      <p v-if="cardholderNameError" class="mt-1 text-xs text-red-500">
        {{ cardholderNameError }}
      </p>
    </div>

    <div>
      <label
        class="block text-xs font-bold text-gray-500 uppercase tracking-wider mb-1.5"
      >
        Card Details
      </label>
      <div
        ref="cardElementContainer"
        class="w-full rounded-xl border border-gray-200 bg-white px-4 py-3 shadow-sm transition-all focus-within:border-primary-500 focus-within:ring-2 focus-within:ring-primary-200"
      ></div>
      <p v-if="errorMessage" class="mt-1 text-xs text-red-500">
        {{ errorMessage }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "StripeCardForm",
  props: {
    publishableKey: {
      type: String,
      required: true
    },
    cardholderName: {
      type: String,
      default: ""
    },
    cardholderNameError: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      stripe: null,
      elements: null,
      cardElement: null,
      errorMessage: ""
    };
  },
  mounted() {
    if (!window.Stripe || !this.publishableKey) {
      console.warn(
        "[StripeCardForm] Stripe.js not found or publishableKey missing"
      );
      return;
    }

    this.stripe = window.Stripe(this.publishableKey);
    this.elements = this.stripe.elements();

    this.cardElement = this.elements.create("card", {
      iconStyle: "solid",
      style: {
        base: {
          iconColor: "#2563eb",
          color: "#111827",
          fontWeight: 400,
          fontFamily:
            "system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
          fontSize: "16px",
          lineHeight: "1.5",
          "::placeholder": {
            color: "#9CA3AF"
          }
        },
        invalid: {
          color: "#DC2626",
          iconColor: "#DC2626"
        }
      }
    });

    this.cardElement.mount(this.$refs.cardElementContainer);
    this.cardElement.on("change", (event) => {
      this.errorMessage = event.error ? event.error.message : "";
    });
  },
  beforeDestroy() {
    if (this.cardElement) {
      this.cardElement.unmount();
    }
  },
  methods: {
    async createToken() {
      if (!this.stripe || !this.cardElement) {
        return { token: null, error: { message: "Stripe not initialized" } };
      }

      if (!this.cardholderName) {
        this.errorMessage = "Please enter the cardholder name";
        return { token: null, error: { message: this.errorMessage } };
      }

      const { token, error } = await this.stripe.createToken(this.cardElement, {
        name: this.cardholderName
      });

      if (error) {
        this.errorMessage = error.message || "Unable to process card";
      } else {
        this.errorMessage = "";
      }

      return { token, error };
    }
  }
};
</script>
